import { useMemo } from 'react'
import { DateRange, MultiSelect } from '../../typings'

export function useGetModeLabel(
  typeName: string,
  value: unknown,
  hideModeSelectField,
) {
  return useMemo(() => {
    switch (typeName) {
      case 'dateRange': {
        const matchType = (value as DateRange).matchType
        return matchType !== 'bt'
          ? matchType === 'gt'
            ? 'After'
            : 'Before'
          : ''
      }
      case 'multiSelect': {
        const modeValue = (value as MultiSelect).mode
        return !hideModeSelectField
          ? modeValue.charAt(0).toUpperCase() + modeValue.slice(1)
          : ''
      }
      default: {
        return ''
      }
    }
  }, [typeName, value])
}
